import React, { Component } from 'react';

class IconCheckmarkCircle extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                <path id="Icon_awesome-check-circle" data-name="Icon awesome-check-circle" d="M14.563,7.563a7,7,0,1,1-7-7A7,7,0,0,1,14.563,7.563Zm-7.81,3.706,5.194-5.194a.452.452,0,0,0,0-.639L11.308,4.8a.452.452,0,0,0-.639,0L6.433,9.034,4.456,7.056a.452.452,0,0,0-.639,0l-.639.639a.452.452,0,0,0,0,.639l2.935,2.935a.452.452,0,0,0,.639,0Z" transform="translate(-0.563 -0.563)" fill="#1d53a5" />
            </svg>

        );
    }
}

export default IconCheckmarkCircle;